import { useNavigate } from "react-router";
import useAppLanguage from "./useAppLanguage";

/**
 * Navigate to a given href with the current language
 */
export const useAppNavigate = () => {
  const navigate = useNavigate();
  const { locationUrlBuilder } = useAppLanguage();

  const appNavigate = (
    href: string,
    options?: {
      openInNewTab?: boolean;
    },
  ) => {
    if (options?.openInNewTab) {
      window.open(locationUrlBuilder(href), "_blank");
    } else {
      navigate(locationUrlBuilder(href));
    }
  };

  return { navigate: appNavigate };
};
